/**
 * Define cell for row FIXME
 * @param {Boolean} readOnly - optional selectable
 * @param {Boolean} selectable - optional default true
 * @param {Function} children - callback function on click cell
 * @param {ChildNode} Component - Component to render as child
 * @param {String} textAling - optional align text for cell [left, right, center] default center
 * @param {String} color - define color for cell
 * @param {Array} style - define style for cell
 */

const style = "odd:bg-white even:bg-zinc-100 hover:bg-lime-100";
const styleSelected = "bg-lime-200";

// const TableRow = memo(function TableRow({
function TableRow({
  readOnly,
  record,
  selectable,
  idx,
  children,
  onClick,
  onDoubleClick,
  selected,
}) {
  if (selectable) {
    return (
      <tr
        key={idx}
        disabled={readOnly}
        className={selected.value ? styleSelected : style}
        onClick={() => onClick(record)}
        onDoubleClick={() => onDoubleClick(record)}
      >
        {children}
      </tr>
    );
  } else {
    return (
      <tr
        key={idx}
        disabled={readOnly}
        className={style}
        onClick={() => onClick(record)}
      >
        {children}
      </tr>
    );
  }
}

export default TableRow;
